import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import SubscribeSection from '../SubscribeSection/SubscribeSection';

export default function FormDialog(props) {
  return (
    <Dialog open={props.trigger} onClose={() => props.setTrigger()} sx={{}}>
      <SubscribeSection trigger={props.trigger} setTrigger={props.setTrigger} variant='popup' />
      <DialogActions>
        <Button onClick={() => props.setTrigger(false)}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
